const email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
const passNumber = /[0-9]/
const passMinus = /[a-z]/
const passMayus = /[A-Z]/
const passSpecial = /[!@#$%^&*()+\-_]/
// const IBAN = /^([A-Z]{2}[ '+'\\'+'-]?[0-9]{2})(?=(?:[ '+'\\'+'-]?[A-Z0-9]){9,30}$)((?:[ '+'\\'+'-]?[A-Z0-9]{3,5}){2,7})([ '+'\\'+'-]?[A-Z0-9]{1,3})?$/
// const IBAN = /^([A-Z]{2}?[0-9]{2})(?=(?:[A-Z0-9]){9,30}$)((?:[A-Z0-9]{3,5}){2,7})([A-Z0-9]{1,3})?$/
const IBAN = /^[A-Z]{2}[0-9]{2}[A-Z0-9]{11,30}$/
const bicSwift = /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/
const NIF = /^[0-9]{8}[A-Z]$/
const CIF = /^[ABCDEFGHJKLMNPQRSUVW][0-9]{7}[0-9A-J]$/
const NIE = /^[XYZ][0-9]{7}[A-Z]$/

const DoubleUpToEightDecimalType = /^\d+([.,]\d{0,8})?$/

const NegativeDoubleUpToEightDecimalType = /^-?[0-9]+([\\.,][0-9]{1,8})?$/

export {
  email,
  passNumber,
  passMinus,
  passMayus,
  passSpecial,
  IBAN,
  bicSwift,
  DoubleUpToEightDecimalType,
  NegativeDoubleUpToEightDecimalType,
  NIF,
  CIF,
  NIE,
}
